<template>
  <div class="class-details-wrapper">
    <div class="class-header">
      <h3 class="section-title">我的课程</h3>
      <span class="class-count">共 {{ classDetailsData.length }} 门课程</span>
    </div>

    <div class="table-container" v-if="classDetailsData.length > 0">
      <el-table 
        :data="classDetailsData" 
        class="modern-table"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        height="500px">
        <el-table-column type="index" width="60" label="序号" align="center">
          <template slot-scope="scope">
            <span class="index-num">{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="classContent" label="课程名称" min-width="280">
          <template slot-scope="scope">
            <div class="course-name">
              <i class="el-icon-video-play"></i>
              <span>{{ scope.row.classContent }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="startDate" label="上课日期" width="140" align="center">
          <template slot-scope="scope">
            <span class="date-cell">
              <i class="el-icon-date"></i>
              {{ scope.row.startDate }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="classTime" label="上课时间" width="140" align="center">
          <template slot-scope="scope">
            <span class="time-cell">
              <i class="el-icon-time"></i>
              {{ scope.row.classTime }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="classState" label="课程状态" width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.classState===0" type="info" size="small" effect="light">预约过期</el-tag>
            <el-tag v-else-if="scope.row.classState===1" type="success" size="small" effect="light">预约成功</el-tag>
            <el-tag v-else-if="scope.row.classState===2" type="primary" size="small" effect="light">学习中</el-tag>
            <el-tag v-else-if="scope.row.classState===3" type="warning" size="small" effect="light">已结束</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="empty-state" v-else>
      <i class="el-icon-notebook-2"></i>
      <p>暂无课程记录</p>
    </div>
  </div>
</template>

<script>
import {
  classDetails
} from "@/api/index"

export default {
  data() {
    return {
      classDetailsData: [],
      headerCellStyle: {
        background: '#F7F8FA',
        color: '#606266',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #EBEEF5'
      },
      cellStyle: {
        color: '#303133',
        fontSize: '14px'
      }
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      classDetails().then(res => {
        if (res.code === "0000") {
          this.classDetailsData = res.data.list
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.class-details-wrapper {
  padding: 0 30px;
}

.class-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.section-title {
  font-size: 18px;
  color: #303133;
  margin: 0;
  font-weight: 500;
  padding-left: 12px;
  border-left: 3px solid #409EFF;
}

.class-count {
  font-size: 13px;
  color: #909399;
}

.table-container {
  background: #FFFFFF;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #EBEEF5;
}

.modern-table {
  width: 100%;
}

.modern-table ::v-deep .el-table__header-wrapper {
  background: #F7F8FA;
}

.modern-table ::v-deep .el-table__row {
  transition: background 0.2s ease;

  &:hover > td {
    background: #F5F7FA !important;
  }
}

.modern-table ::v-deep .el-table__body tr:nth-child(even) {
  background: #FAFBFC;
}

.modern-table ::v-deep td.el-table__cell {
  border-bottom: 1px solid #F0F2F5;
}

.index-num {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: #F0F2F5;
  border-radius: 4px;
  font-size: 12px;
  color: #606266;
}

.course-name {
  display: flex;
  align-items: center;
  color: #303133;
  font-weight: 500;

  i {
    margin-right: 10px;
    color: #409EFF;
    font-size: 18px;
  }
}

.date-cell {
  color: #606266;
  font-size: 13px;

  i {
    margin-right: 6px;
    color: #909399;
  }
}

.time-cell {
  color: #909399;
  font-size: 13px;

  i {
    margin-right: 6px;
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  color: #C0C4CC;

  i {
    font-size: 48px;
    margin-bottom: 16px;
  }

  p {
    font-size: 14px;
    margin: 0;
  }
}
</style>
